import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/joy";
import { motion, AnimatePresence } from "framer-motion";
import Favorite from "@mui/icons-material/Favorite";
import { useTranslation } from "react-i18next";

const START_SECONDS = 15;

const randomVotes = () => {
  const total = 16 + Math.floor(Math.random() * 19);
  const percentGirl = 45 + Math.floor(Math.random() * 26);
  const girl = Math.round((percentGirl / 100) * total);
  const boy = total - girl;
  return { boy, girl };
};

const randomName = (gender, t) =>
  gender === "girl"
    ? t("demo.girlNames", { returnObjects: true })?.[Math.floor(Math.random() * 4)] || "Zosia"
    : t("demo.boyNames", { returnObjects: true })?.[Math.floor(Math.random() * 4)] || "Antek";

// Domyślne imiona jeśli nie masz ich w tłumaczeniach, dodaj je!
const BOY_NAMES = ["Antek", "Olek", "Franek", "Staś"];
const GIRL_NAMES = ["Zosia", "Ala", "Maja", "Ola"];

const DEMO_INITIAL = (t) => {
  const gender = Math.random() < 0.5 ? "girl" : "boy";
  // Jeśli nie dodałeś osobnych demo.girlNames / demo.boyNames to użyj powyższych
  const name =
    gender === "girl"
      ? (t("demo.girlNames", { returnObjects: true })?.[Math.floor(Math.random() * 4)] ?? GIRL_NAMES[Math.floor(Math.random() * 4)])
      : (t("demo.boyNames", { returnObjects: true })?.[Math.floor(Math.random() * 4)] ?? BOY_NAMES[Math.floor(Math.random() * 4)]);
  return {
    gender,
    baby_name: name,
    votes: randomVotes(),
    likes: 1 + Math.floor(Math.random() * 12),
  };
};

const DemoReveal = () => {
  const { t } = useTranslation();
  const [demo, setDemo] = useState(() => DEMO_INITIAL(t));
  const [showGender, setShowGender] = useState(false);
  const [textIdx, setTextIdx] = useState(0);
  const [timer, setTimer] = useState(START_SECONDS);

  // Odliczanie
  useEffect(() => {
    if (timer <= 0) {
      setShowGender(true);
      return;
    }
    const tmr = setTimeout(() => setTimer(timer - 1), 1000);
    return () => clearTimeout(tmr);
  }, [timer]);

  // Zabawny tekst co 4 sek
  useEffect(() => {
    if (showGender) return;
    const interval = setInterval(() => {
      setTextIdx((prev) => (prev + 1) % t("demo.funnyTexts", { returnObjects: true }).length);
    }, 4000);
    return () => clearInterval(interval);
  }, [showGender, t]);

  const handleVote = (type) => {
    setDemo((prev) => ({
      ...prev,
      votes: { ...prev.votes, [type]: prev.votes[type] + 1 },
    }));
  };
  const handleLike = () => {
    setDemo((prev) => ({ ...prev, likes: prev.likes + 1 }));
  };

  // RESETUJ wszystko
  const handleReset = () => {
    setDemo(DEMO_INITIAL(t));
    setShowGender(false);
    setTextIdx(0);
    setTimer(START_SECONDS);
  };

  const funnyTexts = t("demo.funnyTexts", { returnObjects: true });

  return (
    <Box
      sx={{
        minHeight: 200,
        py: 3,
        px: 1,
        borderRadius: "18px",
        background: "#fff",
        boxShadow: "0 4px 22px #e3eaff30",
        maxWidth: 390,
        mx: "auto",
        my: 5,
        textAlign: "center",
        position: "relative",
      }}
    >
      {!showGender ? (
        <>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.45 }}
            style={{ fontSize: 19, fontWeight: 700, color: "#2d3c88", marginBottom: 16 }}
          >
            {funnyTexts[textIdx]}
          </motion.div>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Bubble value={0} label={t("demo.days")} />
            <Bubble value={0} label={t("demo.hours")} />
            <Bubble value={Math.floor(timer / 60)} label={t("demo.minutes")} />
            <Bubble value={timer % 60} label={t("demo.seconds")} />
          </Box>
          <DemoVotingBarHome
            boy={demo.votes.boy}
            girl={demo.votes.girl}
            onVote={handleVote}
            t={t}
          />
          <DemoLiveHeartsHome count={demo.likes} onLike={handleLike} t={t} />
        </>
      ) : (
        <motion.div
          initial={{ opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, type: "spring" }}
          style={{ marginTop: 16 }}
        >
          <Typography level="h2" sx={{ color: "#ec407a", mb: 1 }}>
            {demo.gender === "girl" ? t("demo.itsAGirl") : t("demo.itsABoy")}
          </Typography>
          <Typography level="body-md" sx={{ mt: 1, mb: 2 }}>
            {t("demo.name", { name: demo.baby_name })}
          </Typography>
          <Button
            variant="soft"
            color="primary"
            size="md"
            onClick={handleReset}
            sx={{ mt: 2 }}
          >
            {t("demo.seeAgain")}
          </Button>
        </motion.div>
      )}
    </Box>
  );
};

// Bubble
function Bubble({ value, label }) {
  return (
    <motion.div
      initial={{ scale: 0.8, y: 10, opacity: 0.7 }}
      animate={{ scale: 1.1, y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 120 }}
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 8px",
      }}
    >
      <motion.div
        style={{
          background: "#fff",
          color: "#2d3c88",
          borderRadius: "2rem",
          fontWeight: 800,
          fontSize: "2rem",
          minWidth: 40,
          minHeight: 40,
          boxShadow: "0 4px 14px 2px #abc9ff23, 0 1.5px #bcd",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {value}
      </motion.div>
      <Typography level="body-xs" sx={{ color: "#5e79b8", mt: 1 }}>
        {label}
      </Typography>
    </motion.div>
  );
}

// DemoVotingBarHome z tłumaczeniem
function DemoVotingBarHome({ boy, girl, onVote, t }) {
  const total = boy + girl;
  const percentBoy = total === 0 ? 50 : Math.round((boy / total) * 100);
  const percentGirl = 100 - percentBoy;
  return (
    <Box sx={{ my: 1, p: 1, borderRadius: 4, background: "#f7f8fa", boxShadow: "0 2px 8px #c2e1ff33", minWidth: 220 }}>
      <Typography level="body-xs" sx={{ mb: 0.5, color: "#5e79b8" }}>
        {t("demo.guessGender")}
      </Typography>
      <Box sx={{ display: "flex", gap: 1, justifyContent: "center", mb: 1 }}>
        <Button color="primary" size="sm" variant="soft" onClick={() => onVote("boy")}>
          👦 {t("demo.boy")}
        </Button>
        <Button color="danger" size="sm" variant="soft" onClick={() => onVote("girl")}>
          👧 {t("demo.girl")}
        </Button>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography sx={{ color: "#1976d2", minWidth: 22, fontSize: "1rem" }}>{boy}</Typography>
        <Box sx={{ flex: 1, mx: 1, position: "relative", height: 12, borderRadius: 6, overflow: "hidden", background: "#e3f2fd" }}>
          <motion.div
            style={{
              position: "absolute",
              left: 0,
              height: "100%",
              width: `${percentBoy}%`,
              background: "linear-gradient(90deg, #2196f3 80%, #e3f2fd 100%)",
              borderRadius: "6px 0 0 6px",
              transition: "width .3s cubic-bezier(.5,2,.6,1)",
            }}
          />
          <motion.div
            style={{
              position: "absolute",
              right: 0,
              height: "100%",
              width: `${percentGirl}%`,
              background: "linear-gradient(90deg, #fff0f6 0%, #ec407a 90%)",
              borderRadius: "0 6px 6px 0",
              transition: "width .3s cubic-bezier(.5,2,.6,1)",
            }}
          />
        </Box>
        <Typography sx={{ color: "#ec407a", minWidth: 22, fontSize: "1rem", textAlign: "right" }}>{girl}</Typography>
      </Box>
      <Typography sx={{ mt: 0.7, color: "#2d3c88", fontWeight: 700, fontSize: "0.99rem" }}>
        {percentBoy}% 👦 / {percentGirl}% 👧
      </Typography>
    </Box>
  );
}

function DemoLiveHeartsHome({ count, onLike, t }) {
  const [hearts, setHearts] = useState([]);
  useEffect(() => {
    if (count <= 0) return;
    setHearts((arr) => [...arr, Math.random().toString(36).substr(2, 9)]);
    const tmo = setTimeout(() => setHearts((arr) => arr.slice(1)), 950);
    return () => clearTimeout(tmo);
  }, [count]);

  return (
    <Box sx={{ position: "relative", minHeight: 34, mt: 1, mb: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <IconButton onClick={onLike} size="md" color="danger" sx={{ fontSize: 18, mr: 1, background: "#fff0f6" }}>
        <Favorite sx={{ fontSize: 24, color: "#ec407a" }} />
      </IconButton>
      <Typography level="body-xs" sx={{ color: "#ec407a", fontWeight: 700 }}>
        {t("demo.likeThisEvent")} {count > 0 && <span>❤️ {count}</span>}
      </Typography>
      <Box sx={{ position: "absolute", left: 24, bottom: 0, pointerEvents: "none", width: 0, height: 0 }}>
        <AnimatePresence>
          {hearts.map((key) => (
            <motion.div
              key={key}
              initial={{
                opacity: 0.8,
                scale: 1 + Math.random() * 0.2,
                x: (Math.random() - 0.5) * 18,
                y: 0,
                rotate: (Math.random() - 0.5) * 25,
              }}
              animate={{
                opacity: [0.9, 1, 0.5, 0],
                y: -48 - Math.random() * 10,
                x: (Math.random() - 0.5) * 18,
                scale: 1 + Math.random() * 0.2,
                rotate: (Math.random() - 0.5) * 20,
                transition: { duration: 0.9, ease: "easeOut" }
              }}
              exit={{ opacity: 0, scale: 0.7, transition: { duration: 0.21 } }}
              style={{
                position: "absolute",
                left: 0,
                bottom: 0,
                fontSize: 20 + Math.random() * 6,
                color: "#ec407a",
                pointerEvents: "none",
                zIndex: 10,
                filter: "drop-shadow(0 2px 7px #faa7f941)",
                userSelect: "none",
              }}
            >❤️</motion.div>
          ))}
        </AnimatePresence>
      </Box>
    </Box>
  );
}

export default DemoReveal;
